import React from 'react';
import { cardNumberInputReact } from '../../utilities/payform';
import unpick from '../../../utilities/unpick';
import CardIcon from './card-icon';
import HiddenComponents from './hidden-components';

export default function CreditCardNumber(props) {
  const { showCardIcon, cardType, isValid, hiddenField } = props;
  const p = unpick(props, ['showCardIcon', 'cardType', 'ariaLabel', 'isValid', 'hiddenField']);

  let hiddenComponents = null;

  if (!hiddenField) {
    hiddenComponents = {
      CardExpirationDate: {
        autoComplete: 'cc-exp',
      },
      CardSecurityCode: {
        autoComplete: 'cc-csc',
      },
      CardHolderName: {
        autoComplete: 'cc-name',
      },
    };
  }

  return (
    <>
      <input
        type="tel"
        {...p}
        className={showCardIcon ? `card-number-input ${p.className}` : p.className}
        {...cardNumberInputReact(props)}
        aria-label={props.ariaLabel || 'Card Number Input'}
        aria-placeholder={props.placeholder || ''}
        aria-invalid={!isValid}
      />

      {showCardIcon && <CardIcon cardType={cardType} styles={showCardIcon} />}

      {!hiddenField && <HiddenComponents hiddenComponents={hiddenComponents} />}
    </>
  );
}

CreditCardNumber.displayName = 'CreditCardNumber';
